import { Vue, store } from './config/index'
import routes from './config/routes'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import VueScrollReveal from 'vue-scroll-reveal'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper)

Vue.use(VueScrollReveal, {
    class: 'v-scroll-reveal',
    duration: 750,
    distance: '15px',
    reset: false,
})

Vue.use(VueRouter)
Vue.use(Meta)

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDYHJphZt5SXfVUMsY0H09vERIykgc1xXU'
    }
})

function loadScript() {
   var head = document.getElementsByTagName('body')[0];
   var script = document.createElement('script');
   script.type = 'text/javascript';
   script.src = 'https://cdn.jsdelivr.net/npm/cookieconsent@3/build/cookieconsent.min.js'
   script.id = 'cookieScript'

   head.appendChild(script);
}

var cookieCallback = function() {
    window.cookieconsent.initialise({
        "palette": {
            "popup": {
                "background": "#231f20",
                "text": "#ffffff"
            },
            "button": {
                "background": "#88c86f",
                "text": "#231f20"
            }
        },
        "position": "bottom-right",
        "content": {
            "message": "Koristimo kolačiće kako bismo Vam osigurali optimalno iskustvo na našem web-u!",
            "dismiss": "Razumijem",
            "link": "Saznaj više",
            "href": "https://supranet.hr/pravila-privatnosti"
        }
    });
};

const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
})

router.beforeEach((to, from, next) => {
    if (!process.env.API_ENDPOINT) {
        throw new Error('API endpoint is invalid!')
    }

    if (from.name) {
        store.state.loading.status = true

        setTimeout(() => {
            store.state.mainMenu.status = false

            setTimeout(() => next(), store.state.loading.duration / 2)
        }, store.state.loading.duration)
    } else {
        next()
    }
})

router.afterEach((to) => {
    store.state.loading.status = false
})

if (!Object.entries)
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj),
        i = ownProps.length,
        resArray = new Array(i); // preallocate the Array

    while (i--)
        resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
};

import Application from './components/App'

window.Vue = Vue

const app = new Vue({
    router,
    store,
    render: h => h(Application)
})

app.$mount('#app')

document.addEventListener('DOMContentLoaded', function () {
    if(document.getElementById('cookieScript') == null){
        loadScript();
    }

    cookieCallback()
})
